import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { activityApi, plantsApi, newsApi, productsApi } from '../utils/api';
import { getImageUrl } from '../config/imageConfig';
import CarouselBanner from './common/CarouselBanner';
import './Home.css';

// 图片资源 - 使用全局配置处理URL
const heroImg = getImageUrl('https://images.unsplash.com/photo-1502082553048-f009c37129b9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2370&q=80');
// 使用本地图片资源
const gardenImg = require('../assets/xlhy/z1.png');
const wildPlantImg = require('../assets/xlhy/z2.png');
const scienceImg = require('../assets/xlhy/z3.png');
// 使用本地图片替代外部链接
const event1Img = require('../assets/xlhy/x4.png');
const event2Img = require('../assets/xlhy/x5.png');
const event3Img = require('../assets/xlhy/x6.png');

// 新增植物展示图片
const plant1Img = getImageUrl('https://images.unsplash.com/photo-1520302630591-fd1c66edc19d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
const plant2Img = getImageUrl('https://images.unsplash.com/photo-1509423350716-97f9360b4e09?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
const plant3Img = getImageUrl('https://images.unsplash.com/photo-1591454371758-644f9d123a81?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
const plant4Img = getImageUrl('https://images.unsplash.com/photo-1517191434949-5e90cd67d2b6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');

// 新增商品展示图片
const product1Img = getImageUrl('https://images.unsplash.com/photo-1531587426902-379f6f7549ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
const product2Img = getImageUrl('https://images.unsplash.com/photo-1556227834-09f1de7a7d14?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
const product3Img = getImageUrl('https://images.unsplash.com/photo-1627483262769-04d0a1401487?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');
const product4Img = getImageUrl('https://images.unsplash.com/photo-1627483297886-49230203df88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');

function Home() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [eventsLoading, setEventsLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [statistics, setStatistics] = useState(null); // 暂时注释掉未使用的变量
  const [featuredEvents, setFeaturedEvents] = useState([]);
  const [featuredPlants, setFeaturedPlants] = useState([]);
  const [featuredNews, setFeaturedNews] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  
  // 临时开关：强制显示静态数据用于调试
  const forceStaticEvents = false; // 设为false时恢复API数据

  // 截断文字的辅助函数
  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  // API调用辅助函数
  const handleApiCall = async (apiFunction, ...args) => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiFunction(...args);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || '请求失败，请稍后重试');
      console.error('API Error:', err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 获取主页数据
  useEffect(() => {
    const fetchHomeData = async () => {
      // 获取统计数据 - 暂时注释掉
      // const statsData = await handleApiCall(homeApi.getStatistics);
      // if (statsData) {
      //   setStatistics(statsData);
      // }

      // 获取近期活动列表 - 使用活动列表API
      try {
        setEventsLoading(true);
        
        // 如果强制使用静态数据，直接跳过API调用
        if (forceStaticEvents) {
          console.log('强制显示静态活动数据');
          setFeaturedEvents([]);
          setEventsLoading(false);
        } else {
        
        const eventsResponse = await activityApi.getList({
          page: 1,
          size: 3,
          sortBy: 'startDate',
          orderBy: 'asc'
        });
        
        if (eventsResponse && eventsResponse.code === 200 && eventsResponse.data) {
          const eventsArray = eventsResponse.data.records || eventsResponse.data || [];
          
          if (eventsArray.length > 0) {
            setFeaturedEvents(eventsArray.slice(0, 3));
          } else {
            // 如果没有数据，尝试获取精选活动
            try {
              const featuredResponse = await activityApi.getFeatured(3);
              if (featuredResponse && featuredResponse.code === 200 && featuredResponse.data) {
                const featuredArray = featuredResponse.data || [];
                setFeaturedEvents(featuredArray.slice(0, 3));
              } else {
                setFeaturedEvents([]);
              }
            } catch (featuredError) {
              setFeaturedEvents([]);
            }
          }
        } else {
          // 如果响应异常，尝试获取精选活动
          try {
            const featuredResponse = await activityApi.getFeatured(3);
            if (featuredResponse && featuredResponse.code === 200 && featuredResponse.data) {
              const featuredArray = featuredResponse.data || [];
              setFeaturedEvents(featuredArray.slice(0, 3));
            } else {
              setFeaturedEvents([]);
            }
          } catch (featuredError) {
            setFeaturedEvents([]);
          }
        }
        } // 关闭 else 块
      } catch (error) {
        console.error('获取活动时发生错误:', error);
        // 使用默认静态数据作为后备
        setFeaturedEvents([]);
      } finally {
        setEventsLoading(false);
      }

      // 获取特色植物
      try {
        console.log('开始获取特色植物数据...');
        const plantsResponse = await plantsApi.getFeaturedPlants();
        console.log('特色植物API响应:', plantsResponse);
        
        if (plantsResponse && plantsResponse.code === 200 && plantsResponse.data) {
          let plantsArray = [];
          
          // 处理不同的数据结构
          if (Array.isArray(plantsResponse.data)) {
            plantsArray = plantsResponse.data;
          } else if (plantsResponse.data.records && Array.isArray(plantsResponse.data.records)) {
            plantsArray = plantsResponse.data.records;
          } else if (plantsResponse.data.list && Array.isArray(plantsResponse.data.list)) {
            plantsArray = plantsResponse.data.list;
          }
          
          console.log(`找到 ${plantsArray.length} 个特色植物`);
          
          // 处理植物数据，特别是图片URL
          const processedPlants = plantsArray.map((plant, index) => {
            // 处理图片URL - 优先使用接口返回的imageUrl字段
            let imageUrl = null;
            if (plant.imageUrl) {
              // 使用getImageUrl处理相对路径
              imageUrl = getImageUrl(plant.imageUrl);
            } else {
              // 备选字段
              const imageFields = [
                plant.mainImageUrl,
                plant.main_image_url,
                plant.mainImage,
                plant.main_image,
                plant.image_url,
                plant.image,
                plant.coverImage,
                plant.cover_image,
                plant.featuredImage,
                plant.featured_image,
                plant.thumbnail,
                plant.thumb
              ];
              
              const rawImageUrl = imageFields.find(field => field && field.length > 0);
              if (rawImageUrl) {
                imageUrl = getImageUrl(rawImageUrl);
              }
            }
            
            console.log(`植物 ${index + 1}: "${plant.name || '无名称'}" - 原始图片URL: ${plant.imageUrl} - 处理后: ${imageUrl}`);
            
            // 保护状态映射
            const conservationStatusMap = {
              'CR': '极危',
              'EN': '濒危', 
              'VU': '易危',
              'NT': '近危',
              'LC': '无危'
            };
            
            return {
              ...plant,
              // 确保必要字段存在
              id: plant.id || index,
              name: plant.name || '未知植物',
              scientificName: plant.scientificName || '',
              description: truncateText(plant.description || '暂无描述', 80),
              imageUrl: imageUrl,
              // 保护状态 - 使用中文显示
              conservationStatus: plant.conservationStatus || '',
              conservationStatusText: conservationStatusMap[plant.conservationStatus] || plant.conservationStatus || '',
              // 植物分类
              category: plant.categoryName || plant.category || '',
              categoryEn: plant.categoryNameEn || '',
              // 特色类型
              featuredType: plant.featuredType || '',
              // 花期
              bloomPeriod: plant.bloomPeriod || '',
              // 分布地区
              location: plant.location || '',
              // 显示顺序
              displayOrder: plant.displayOrder || 0,
              // 是否特色展示
              isFeatured: plant.isFeatured || false
            };
          });
          
          // 按displayOrder排序，然后取前6个
          const sortedPlants = processedPlants.sort((a, b) => {
            // 先按displayOrder排序，再按id排序
            if (a.displayOrder !== b.displayOrder) {
              return a.displayOrder - b.displayOrder;
            }
            return a.id - b.id;
          });
          
          setFeaturedPlants(sortedPlants.slice(0, 6));
          console.log('特色植物设置成功，共', sortedPlants.length, '个植物');
        } else {
          console.log('未获取到特色植物数据，将显示默认内容');
          setFeaturedPlants([]);
        }
      } catch (error) {
        console.error('获取特色植物时发生错误:', error);
        setFeaturedPlants([]);
      }

      // 获取特色新闻
      try {
        console.log('开始获取特色新闻数据...');
        const newsData = await handleApiCall(newsApi.getNewsByCategory, 'wmdts');
        console.log('特色新闻API响应结构:', newsData ? Object.keys(newsData) : 'null');
        
        if (newsData) {
          // API返回的数据结构可能是 { records: [...] } 或直接是数组
          let newsArray = [];
          
          if (Array.isArray(newsData)) {
            newsArray = newsData;
          } else if (newsData.records && Array.isArray(newsData.records)) {
            newsArray = newsData.records;
          } else if (newsData.data && Array.isArray(newsData.data)) {
            newsArray = newsData.data;
          } else if (newsData.list && Array.isArray(newsData.list)) {
            newsArray = newsData.list;
          }
          
          console.log(`找到 ${newsArray.length} 条新闻数据`);
          
          if (newsArray.length > 0) {
            // 处理图片URL和数据标准化
            const processedNewsArray = newsArray.map((news, index) => {
              // 支持多种图片字段名，按优先级排序
              const imageUrl = news.featuredImage || news.featured_image || news.image || news.cover_image || news.imageUrl || news.img;
              
              let processedImageUrl = null;
              if (imageUrl) {
                // 如果是相对路径，直接拼接正确的服务器地址
                if (imageUrl.startsWith('/') || !imageUrl.includes('http')) {
                  processedImageUrl = `https://www.lsxlbg.com${imageUrl}`;
                } else {
                  // 如果已经是完整URL，直接使用
                  processedImageUrl = imageUrl;
                }
              }
              
              console.log(`新闻 ${index + 1}: "${news.title || '无标题'}" - 图片: ${processedImageUrl || '无图片'}`);
              
              return {
                ...news,
                // 确保必要字段存在
                id: news.id || index,
                title: news.title || '无标题',
                summary: news.summary || news.excerpt || news.content?.substring(0, 100) || '暂无摘要',
                featuredImage: processedImageUrl
              };
            });
            
            setFeaturedNews(processedNewsArray.slice(0, 3));
            console.log('特色新闻设置成功');
          } else {
            console.log('新闻数组为空，将显示默认内容');
            setFeaturedNews([]);
          }
        } else {
          console.log('未获取到新闻数据，将显示默认内容');
          setFeaturedNews([]);
        }
      } catch (error) {
        console.error('获取特色新闻时发生错误:', error);
        setFeaturedNews([]);
      }

      // 获取精选商品
      const productsData = await handleApiCall(productsApi.getHomepageProducts, { isFeatured: true, size: 6 });
      if (productsData) {
        // API返回的数据结构是 { data: { list: [...] } }
        const productsArray = productsData.list || [];
        setFeaturedProducts(productsArray.slice(0, 6));
      }
    };

    fetchHomeData();
  }, [forceStaticEvents]);





  return (
    <>
      {/* Hero Section - 使用轮播图组件 */}
      <CarouselBanner 
        categoryNameEn="HomePageBanner"
        defaultImage={heroImg}
        defaultTitle="植物与未来"
        defaultSubtitle="探索植物对人类福祉、可持续发展和生态保护的重要性，发现庐山的自然瑰宝。"
        defaultLinkUrl="/garden"
        defaultLinkText="探索花园"
        className="hero-section"
      />

      <div className="home-content-wrapper">
        {/* 特色区域 - 按照设计图的交叉布局 */}
        <section className="garden-modules-section">
          <div className="garden-modules-grid">
            {/* 第一行：两个卡片 */}
            <div className="module-row">
              {/* 左侧：图片卡片 */}
              <div className="module-card image-card">
                <img src={gardenImg} alt="热带山南植物园" />
              </div>
              {/* 右侧：内容卡片 */}
              <div className="module-card content-card">
                <h3>热带山南植物园</h3>
                <p>万物有灵共生，草木有情共荣，探索我们独特的花园区域，体验药用植物和观赏的多样性，感受中华文化的传承。</p>
                <Link to="/garden" className="module-link">游览花园</Link>
              </div>
            </div>

            {/* 第二行：两个卡片（反向排列） */}
            <div className="module-row ">
              {/* 左侧：内容卡片 */}
              <div className="module-card content-card">
                <h3>山地药用植物园</h3>
                <p>依托庐山山地生态环境，在海拔1000-1300米的高郊口山谷中，专设药园展示山地药用植物，目前已收集药用植物300余种，涵盖草本、灌木、藤本及珍稀濒危物种，药园不仅是植物资源库，更是中医药文化与生态保护的活态课堂。</p>
                <Link to="/medicinal-garden" className="module-link">探索植物</Link>
              </div>
              {/* 右侧：图片卡片 */}
              <div className="module-card image-card">
                <img src={wildPlantImg} alt="山地药用植物园" />
              </div>
            </div>

            {/* 第三行：两个卡片 */}
            <div className="module-row">
              {/* 左侧：图片卡片 */}
              <div className="module-card image-card">
                <img src={scienceImg} alt="省市重点实验室" />
              </div>
              {/* 右侧：内容卡片 */}
              <div className="module-card content-card">
                <h3>省市重点实验室</h3>
                <p>以中部道地药材与特色药用植物为核心，研究其生态特性与质量形成机制，通过基因挖掘和分子育种创新种质，建立标准化生产体系，开发抗炎活性成分并推动产业化，减少对野生资源依赖，实现中药材产业提质增效与可持续发展。</p>
                <Link to="/learning" className="module-link">了解详情</Link>
              </div>
            </div>
          </div>
        </section>
        
        {/* 活动部分 */}
        <section className="events-section">
          <h2>近期活动</h2>
          {eventsLoading && <div className="loading-spinner">加载活动中...</div>}
          <div className="events-grid">
            {featuredEvents.length > 0 ? (
              featuredEvents.map((event, index) => {
                // 为每个活动分配默认图片
                const defaultImages = [event1Img, event2Img, event3Img];
                const eventImage = getImageUrl(
                  event.featured_image || 
                  event.featured_image_url || 
                  event.image || 
                  event.image_url || 
                  event.cover_image || 
                  event.featuredImage
                ) || defaultImages[index % 3];
                
                return (
                  <div 
                    key={event.id} 
                    className="event-card"
                    onClick={() => navigate(`/event/${event.id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <img 
                      src={eventImage} 
                      alt={event.title} 
                      onError={(e) => { 
                        console.log('活动图片加载失败，使用默认图片');
                        e.target.src = defaultImages[index % 3]; 
                      }}
                    />
                    <div className="event-content">
                      <span className="event-type">{event.category?.name || event.categoryName || event.type || '活动'}</span>
                      <h3>{event.title}</h3>
                      <p className="event-description">
                        {truncateText(
                          event.description || 
                          event.summary || 
                          event.content || 
                          event.brief || 
                          '精彩活动，等您参与', 
                          45
                        )}
                      </p>
                      {/* <span className="event-date">
                        {event.start_date ? (
                          new Date(event.start_date).toLocaleDateString('zh-CN', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })
                        ) : (
                          event.date || '待定'
                        )}
                      </span> */}
                    </div>
                  </div>
                );
              })
            ) : (
              // 默认静态内容作为后备
              <>
                <div 
                  className="event-card"
                  onClick={() => navigate('/event/1')}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={event1Img} alt="植物科普讲座" />
                  <div className="event-content">
                    <span className="event-type">讲座</span>
                    <h3>药用植物的现代应用</h3>
                    <p className="event-description">探索传统药用植物在现代医学中的应用价值，了解中草药的科学原理。</p>
                    <span className="event-date">2023年10月15日</span>
                  </div>
                </div>
                <div 
                  className="event-card"
                  onClick={() => navigate('/event/2')}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={event2Img} alt="自然观察工作坊" />
                  <div className="event-content">
                    <span className="event-type">工作坊</span>
                    <h3>四季植物观察与记录</h3>
                    <p className="event-description">学习专业的植物观察技巧，记录四季变化中的植物生长奥秘。</p>
                    <span className="event-date">2023年10月21日</span>
                  </div>
                </div>
                <div 
                  className="event-card"
                  onClick={() => navigate('/event/3')}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={event3Img} alt="家庭植物日" />
                  <div className="event-content">
                    <span className="event-type">家庭活动</span>
                    <h3>亲子植物探索日</h3>
                    <p className="event-description">带领孩子走进自然，在游戏中认识植物，培养环保意识。</p>
                    <span className="event-date">2023年10月28日</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
        
        {/* 特色植物展示 */}
        <section className="plants-showcase-section">
          <h2>特色植物展示</h2>
          <p className="section-subtitle">探索庐山植物园的珍稀植物资源，了解它们的独特魅力与生态价值</p>
          <div className="plants-grid">
            {featuredPlants.length > 0 ? (
              featuredPlants.map((plant, index) => {
                // 处理植物图片
                const plantImage = getImageUrl(plant.imageUrl) || plant1Img;
                
                // 决定显示的标签
                const getPlantTags = () => {
                  const tags = [];
                  
                  // 保护状态标签（优先级最高）
                  if (plant.conservationStatusText) {
                    const statusTypeMap = {
                      '极危': 'critical',
                      '濒危': 'endangered', 
                      '易危': 'vulnerable',
                      '近危': 'near-threatened',
                      '无危': 'least-concern'
                    };
                    tags.push({ 
                      text: plant.conservationStatusText, 
                      type: statusTypeMap[plant.conservationStatusText] || 'conservation'
                    });
                  }
                  
                  // 特色类型标签
                  if (plant.featuredType) {
                    const typeMap = {
                      'medicinal': { text: '药用植物', type: 'medicinal' },
                      'endemic': { text: '特有种', type: 'endemic' },
                      'rare': { text: '珍稀植物', type: 'rare' },
                      'ornamental': { text: '观赏植物', type: 'ornamental' },
                      'common': { text: '常见植物', type: 'common' }
                    };
                    
                    if (typeMap[plant.featuredType]) {
                      tags.push(typeMap[plant.featuredType]);
                    }
                  }
                  
                  // 分类标签（如果没有特色类型）
                  if (tags.length === 0 || tags.length === 1) {
                    if (plant.category) {
                      tags.push({ text: plant.category, type: 'category' });
                    }
                  }
                  
                  // 确保至少有一个标签
                  if (tags.length === 0) {
                    tags.push({ text: '特色植物', type: 'default' });
                  }
                  
                  return tags;
                };
                
                const plantTags = getPlantTags();
                
                return (
                  <div key={plant.id} className="plant-card">
                    <div className="plant-image">
                      <img 
                        src={plantImage} 
                        alt={plant.name}
                        onError={(e) => { 
                          console.log(`植物图片加载失败: ${plant.name}`);
                          e.target.src = plant1Img; 
                        }}
                      />
                      {/* 添加悬浮遮罩显示学名 */}
                      {plant.scientificName && (
                        <div className="plant-overlay">
                          <span className="scientific-name">{plant.scientificName}</span>
                        </div>
                      )}
                    </div>
                    <div className="plant-content">
                      <h3>{plant.name}</h3>
                      {plant.scientificName && (
                        <p className="plant-scientific-name">{plant.scientificName}</p>
                      )}
                      <p className="plant-description">{plant.description}</p>
                      {/* 显示多个标签 */}
                      {/* <div className="plant-tags">
                        {plantTags.map((tag, tagIndex) => (
                          <span key={tagIndex} className={`plant-tag plant-tag-${tag.type}`}>
                            {tag.text}
                          </span>
                        ))}
                      </div> */}
                      {/* 显示额外信息 */}
                      {/* <div className="plant-info">
                        {plant.bloomPeriod && (
                          <span className="plant-bloom-period">
                            🌸 {plant.bloomPeriod}
                          </span>
                        )}
                        {plant.location && (
                          <span className="plant-location" title={plant.location}>
                            📍 {truncateText(plant.location, 20)}
                          </span>
                        )}
                      </div> */}
                    </div>
                  </div>
                );
              })
            ) : (
              // 默认静态内容作为后备
              <>
                <div className="plant-card">
                  <div className="plant-image">
                    <img src={plant1Img} alt="银杏树" />
                  </div>
                  <div className="plant-content">
                    <h3>银杏树</h3>
                    <p>作为\"活化石\"，银杏树有着悠久的历史，在中医药中具有重要地位。</p>
                    <span className="plant-tag">珍稀植物</span>
                  </div>
                </div>
                
                <div className="plant-card">
                  <div className="plant-image">
                    <img src={plant2Img} alt="芍药" />
                  </div>
                  <div className="plant-content">
                    <h3>芍药</h3>
                    <p>中国传统名花，既是观赏植物也是重要的中药材。</p>
                    <span className="plant-tag">花卉</span>
                  </div>
                </div>
                
                <div className="plant-card">
                  <div className="plant-image">
                    <img src={plant3Img} alt="五味子" />
                  </div>
                  <div className="plant-content">
                    <h3>五味子</h3>
                    <p>具有重要药用价值的植物，能够镇静安神、补肾益气。</p>
                    <span className="plant-tag">药用植物</span>
                  </div>
                </div>
                
                <div className="plant-card">
                  <div className="plant-image">
                    <img src={plant4Img} alt="杜仲" />
                  </div>
                  <div className="plant-content">
                    <h3>杜仲</h3>
                    <p>传统名贵中药材，对于肝肾有良好的滋补功效。</p>
                    <span className="plant-tag">药用植物</span>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="plants-link-container">
            <Link to="/plants" className="feature-link">探索更多植物</Link>
          </div>
        </section>
        
        {/* 店铺商品展示区 */}
        {/* <section className="shop-section">
          <h2>精选商品</h2>
          {loading && <div className="loading-spinner">加载中...</div>}
          {error && <div className="error-message">{error}</div>}
          <div className="products-grid">
            {featuredProducts.length > 0 ? (
              featuredProducts.map((product) => (
                <div key={product.id} className="product-card">
                   <div className="product-image">
                     <img 
                       src={getImageUrl(product.featured_image || product.image || product.main_image) || product1Img} 
                       alt={product.name}
                       onError={(e) => { 
                         console.log('商品图片加载失败，使用默认图片:', e.target.src);
                         e.target.src = product1Img; 
                       }}
                     />
                     {product.is_new === 1 && <div className="product-badge">新品</div>}
                     {product.is_hot === 1 && <div className="product-badge">热销</div>}
                     {product.is_featured === 1 && product.is_new !== 1 && product.is_hot !== 1 && <div className="product-badge">推荐</div>}
                   </div>
                   <div className="product-content">
                     <h3>{product.name}</h3>
                     <p>{product.description}</p>
                     <div className="product-price">
                       ¥{product.sale_price}
                       {product.original_price && product.original_price > product.sale_price && (
                         <span className="original-price">¥{product.original_price}</span>
                       )}
                     </div>
                     <Link to={`/shop/product/${product.id}`} className="shop-button">查看详情</Link>
                   </div>
                 </div>
              ))
            ) : (
              // 默认静态内容作为后备
              <>
                <div className="product-card">
                  <div className="product-image">
                    <img src={product1Img} alt="植物精油" />
                    <div className="product-badge">新品</div>
                  </div>
                  <div className="product-content">
                    <h3>植物精油套装</h3>
                    <p>由园区植物提取的天然精油，放松身心。</p>
                    <div className="product-price">¥268.00</div>
                    <Link to="/shop/product1" className="shop-button">查看详情</Link>
                  </div>
                </div>
                
                <div className="product-card">
                  <div className="product-image">
                    <img src={product2Img} alt="草本茶包" />
                  </div>
                  <div className="product-content">
                    <h3>庐山草本茶包</h3>
                    <p>精选多种草本植物，提神醒脑、润喉养生。</p>
                    <div className="product-price">¥88.00</div>
                    <Link to="/shop/product2" className="shop-button">查看详情</Link>
                  </div>
                </div>
                
                <div className="product-card">
                  <div className="product-image">
                    <img src={product3Img} alt="香草盆栽" />
                    <div className="product-badge">热销</div>
                  </div>
                  <div className="product-content">
                    <h3>迷你香草盆栽</h3>
                    <p>适合室内种植的小型香草植物，美化环境。</p>
                    <div className="product-price">¥128.00</div>
                    <Link to="/shop/product3" className="shop-button">查看详情</Link>
                  </div>
                </div>
                
                <div className="product-card">
                  <div className="product-image">
                    <img src={product4Img} alt="植物种子套装" />
                  </div>
                  <div className="product-content">
                    <h3>植物种子套装</h3>
                    <p>精选四季适宜种植的花卉种子，附详细种植指南。</p>
                    <div className="product-price">¥58.00</div>
                    <Link to="/shop/product4" className="shop-button">查看详情</Link>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="shop-link-container">
            <Link to="/shop" className="feature-link">浏览所有商品</Link>
          </div>
        </section> */}

        {/* 注册部分 */}
        <section className="newsletter-section">
          <h2>关注我们的动态</h2>
          <h3>订阅我们的电子通讯，了解最新活动和科研成果</h3>
          <form className="newsletter-form">
            <input type="email" placeholder="您的电子邮箱" required />
            <button type="submit" className="hero-button">订阅</button>
          </form>
        </section>
      </div>
    </>
  );
}

export default Home;
